<template>
  <div>
    <personal-form
      :title="title"
      :form-model="formModel"
      :required="required"
      :is-firm-manager="true"
      :show-needs-translator-form="showNeedsTranslatorForm"
      :allow-address-check="allowAddressCheck"
      :view-mode="isViewMode"
      :party-roles="partyRoles"
      :existing-parties="existingParties"
      :show-party-role="showPartyRole"
    ></personal-form>

    <national-address-form
      v-if="formModel.partyType"
      :form-model="formModel.nationalAddress"
      :national-addresses="formModel.nationalAddresses"
      :show-more-address-details="showMoreAddressDetails"
      :required="required"
      :is-view-mode="isViewMode"
    ></national-address-form>
  </div>
</template>

<script>
import PersonalForm from './personal-form';
import NationalAddressForm from './national-address-form';

export default {
  inject: ['$validator'],
  components: {
    PersonalForm,
    NationalAddressForm,
  },
   props: ['title', 'formModel', 'required', 'showNeedsTranslatorForm', 'isViewMode', 'showMoreAddressDetails', 'allowAddressCheck','showPartyRole' // اظهار صفة الطرف
  , 'partyRoles', 'existingParties'],
};
</script>
